<!--
 * @Author: songyzh
 * @Date: 2020-08-20 11:11:05
 * @LastEditors: songyzh
 * @LastEditTime: 2021-05-12 14:56:32
-->
<template>
  <Dropdown @on-click="onDropdownClick">
    <a href="javascript:void(0)">
      <span
        calss="inline-block"
        style="cursor: pointer; line-height: 25px; height: 25px"
      >
        <Icon type="ios-contact" size="25" style="vertical-align: -5px" />
        {{ userName }}
      </span>
      <Icon type="ios-arrow-down"></Icon>
    </a>
    <DropdownMenu slot="list">
      <DropdownItem name="logout">注销</DropdownItem>
      <DropdownItem name="usermanager" v-if="isAdmin">用户管理</DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import storage from '@/utils/local-storage';

export default {
  name: 'UserInfo',
  data() {
    return {
      userName: '',
      isAdmin: false
    };
  },
  mounted() {
    const userInfo = storage.getItem('user');
    debugger;
    this.isAdmin = userInfo.loginname === 'admin';
    this.userName = userInfo.username;
  },
  methods: {
    onDropdownClick(name) {
      switch (name) {
        case 'logout':
          storage.remove('user');
          this.$router.push('/login');
          break;
        default:
          this.$router.push('/user-manage');
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-dropdown {
  display: inline-block;
  line-height: 1;
}
::v-deep .ivu-dropdown-rel {
  position: relative;
  height: 3rem;
}
</style>
